import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { cpf } from 'cpf-cnpj-validator';

@Directive({
  selector: '[document-validator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: DocumentValidatorDirective,
    multi: true
  }]
})
export class DocumentValidatorDirective implements Validator {

  constructor() { }

  validate(control: AbstractControl): ValidationErrors {
    const documentIsValid = cpf.isValid(control.value);
    return  control?.value?.length > 0 && !documentIsValid ? { documentIsInvalid: true } : null;
  }

}
